import { NestedInvestmentJurisdictionShortResponse } from '../../../../web-api-client';
import { InvestmentJurisdictionShort } from '../../models/investment-jurisdiction-short';
import { mapCountryFromResponse } from '../country/map-country-from-response';

export const mapInvestmentJurisdictionFromResponseNested = (
  response: NestedInvestmentJurisdictionShortResponse
): InvestmentJurisdictionShort => ({
  investmentJurisdictionId: response.investmentJurisdictionId!,
  name: response.country ? mapCountryFromResponse(response.country).name : '',
  country: response.country
    ? mapCountryFromResponse(response.country)
    : undefined,
});
